import { Box } from "@mui/material";
import Button from "../../../design/Button";
import colors from "../../../design/colors";
import styles from "../../../design/styles";
import customStyles from "./styles";

const VerificationLimitReached = ({ maxContacts = 5, onCompleteKyc, onCancel }) => {
  return (
    <Box
      sx={customStyles.container}
    >
      {/* Content */}
      <Box
        sx={customStyles.numberNotVerifiedContent}
      >
        <p
          className="t6 medium-font nc-gray-900"
          style={customStyles.pl1}
        >
          Verification limit reached
        </p>
        <p
          className="t7 regular-font nc-gray-700"
          style={customStyles.pl2}
        >
          Your Instant Trial allows verification of up to{" "}
          <span className="medium-font">{maxContacts} phone numbers</span> for
          outbound calls. You've reached this limit.
        </p>
        <p
          className="t7 regular-font nc-gray-700"
          style={customStyles.pl2}
        >
          Complete KYC to remove outgoing call restrictions during trial.
        </p>
      </Box>

      {/* Actions */}
      <Box
        sx={customStyles.actionsContainer}
      >
        <Button
          hierarchy="white"
          variant="outlined"
          buttonText="Cancel"
          disabled={false}
          onClick={onCancel}
          styleOverride={{
            height: "36px",
            padding: "8px 16px",
            ...styles.t7,
          }}
        />
        <Button
          hierarchy="green"
          variant="contained"
          buttonText="Complete KYC"
          disabled={false}
          onClick={onCompleteKyc}
          styleOverride={{
            height: "36px",
            padding: "8px 16px",
            ...styles.t7,
            color: colors.ic_white,
          }}
        />
      </Box>
    </Box>
  );
};

export default VerificationLimitReached;
